import { useEffect, useRef } from "react";
import styles from "./TimeTop.module.scss";

const TimeTop = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const formatter = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "long",
    });

    const updateTime = () => {
      if (el) {
        el.textContent = formatter.format(new Date());
      }
    };

    // Update immediately
    updateTime();

    // Calculate milliseconds until next minute
    const now = new Date();
    const msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    // Sync to top of minute, then update every minute
    const timeout = setTimeout(() => {
      updateTime();
      const interval = setInterval(updateTime, 60000);
      el._interval = interval;
    }, msUntilNextMinute);

    return () => {
      clearTimeout(timeout);
      if (el?._interval) clearInterval(el._interval);
    };
  }, []);

  return <div ref={ref} className={styles.timetop}></div>;
};

export default TimeTop;
